<template>
<section class="container list-page">
    <div >
        <!-- <a>Link</a> -->
         <Breadcrumb 

            :levelTwoText = "'Countries'"
            :levelTwoLink = "'/countries'"
            :levelThreeText = "'United States'"
            :levelThreeLink = "'/countries/United States'"
            :levelFourText = "'All States'"
        
        />
        <Heading 
            :heading="'US States'"
        /> 


        <div>
               
                <div class="spacer" style="height:60px"></div>  

                <div style="max-width:500px; margin-left:auto; margin-right:auto">
                    <b-field label="Search:">
                        <b-input v-model="filterInput" placeholder='start typing...'></b-input>
                    </b-field>
                </div>

                <div class="spacer" style="height:60px"></div> 

                <ul v-if="!isLoading">
                    <li  class="list-link ridertags-row" v-for="state in us_states" v-bind:key="state" >
                        <div v-if = "(  filterInput != '' && state.toLowerCase().includes(filterInput.toLowerCase()) || filterInput == ''  )"
                        class="card" style="margin-bottom:25px; margin-left:auto; margin-right:auto; padding:20px;" >
                        <!-- <pre>{{state}}</pre> -->
                            <router-link v-bind:to="'/' + 'countries/United States' + '/' + state">
                            <div class="columns is-mobile is-vcentered">
                                <div class="column has-text-left ">
                                    <router-link class="is-size-5 is-size-6-mobile title" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + 'countries/United States' + '/' + state">{{state}}</router-link>

                                
                                </div>
                                <div class="column has-text-right is-narrow" >
                                    <div class="columns is-mobile">
                                    <div class="column is-narrow">
                                        <div class="small-label">Posts</div>
                                        <p v-if="statesObj[state]">{{statesObj[state]['post_count']}}</p>
                                        <p v-if="!statesObj[state]">0</p>
                                    </div>
                                    
                                    
                                    </div>
                                </div>

                            </div>
                            
                            </router-link>
                        </div>
                    </li>
                </ul>
            <!-- </div> -->

        </div>
        <!-- <pre>{{type}}</pre> -->
        <div class="section card" ref="results" v-if="isLoading">
            <b-icon class="fas fa-spinner fa-spin"></b-icon>
            Loading...
        </div>
        
        <div class="spacer" style="height:100px"></div>



    </div>
    </section>
</template>

<script>
import Heading from '@/components/Heading';
import Breadcrumb from '@/components/Breadcrumb';
import {us_states} from "../data.js";
// import Book from '@/components/Book';

export default {
  name: 'States',
  props: ['type'],
  components: {  Heading, Breadcrumb },
  data () {
    return {
       filterInput: "",
       us_states: us_states,
       isLoading: false,
       statesObj: {}
        // type: this.type
    }
  },
  computed: {
    sortedRows() {
        if (this.orderby == 'posts') {
            return [...this.links].sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return [...this.links].sort((a, b) => (this.$countrymap[a.id] > this.$countrymap[b.id]) ? 1 : -1);
        }
    }
  },
//   metaInfo() {
    
//         return {
//             title: '**** Browse | Bike Sleep Bike',
//             description: "Find bike travel blogs"
            
//         }
//     },
  methods: {
   
      getDisplayText(val) {
          if (this.displayTextMap[val]) {
              return this.displayTextMap[val];
          } else {
              return val;
          }

      },
    
      comparePostCount(a, b) {
        //   console.log(a);
          if (a.post_count > b.post_count) {return -1; }
          if (a.post_count < b.post_count) {return 1; }
          return 0;
      },
      titleCase(str) {
        //   console.log(str);
            str = str.toLowerCase();
            str = str.split(' ');
            for (var i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
          
            }
            return str.join(' ');
        },
        getPostCounts() {
            var result = [];
            var that = this;
            this.isLoading = true;
            this.$db.collection("page_counts").doc("subregions").get()
            .then(function(doc) {
                if (doc.exists) {
                    that.statesObj = doc.data();
                    that.isLoading = false;
                        // that.links = doc.data();
                } else {
                    console.log("ERROR: Can't fetch post counts for states");
                    that.isLoading = false;
                }
            })
            .catch(function(error) {
                console.log("Error getting post counts for states: ", error);
                that.isLoading = false;
            });
        },
       
        
  
  },
   metaInfo() {
        var title =  'States'
        var description = "Browse " + title + " at BikeSleepBike, a directory of bicycle touring and bikepacking blogs from all over the world.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com/" + this.type}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    

  },
 
  mounted() {
    // this.type = this.$route.params.type;
    // if (this.type == "routes") {
    //     this.getRoutes();
    // }
    // console.log("mounted");
    this.getPostCounts();
  },
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .list-link {
        margin-bottom:10px;
        font-size: 1.1em;
    }
    /* .ridertag-row {
        padding: 30px;
        background-color: white;
    } */
    .list-link .card a {
        color:black;
    }
    .ridertags-row {
        max-width:500px;
        margin-left:auto;
        margin-right:auto;
    }
    .sites-row {
        max-width:800px;
        margin-left:auto;
        margin-right:auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/States.vue